import styled from "styled-components";

export const TimeLine = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 16px;

  @media (min-width: 885px) {
    order: 1;
    width: 48%;
    min-width: 400px;
    height: 1900px;
    padding: 0px 0px 0px 25px;
    padding-left: 50px;
    overflow-x: hidden;
  }

  @media (min-width: 1150px) {
    height: 1500px;
  }

  @media (min-width: 1560px) {
    height: 1020px;
  }

  /* @media (max-width: 885px) {
    width: 80%;
  }
  @media (max-width: 670px) {
    width: 90%;
  }
  @media (max-width: 400px) {
    align-items: center;
  } */
`;
